<div class="task-container">
  <div class="page-header">
    <span class="page-title">Atendimentos</span>
  </div>
  <span class="h2" style="font-weight: bold">Filtros</span>
  <div class="filters">
    <mat-form-field subscriptSizing="dynamic" style="align-self: end;" [matTooltip]="'Pesquise por protocolo, descrição, contato, tipo, responsável ou assunto'">
      <mat-label>Pesquisar</mat-label>
      <input matInput (keyup)="search($event)" placeholder="Ex. Mia" #input>
    </mat-form-field>
    <app-person-picker [selectedPeople]="selectedPeople" [people]="usersToShowBadges" (onSelectionChange)="personSelected($event)"></app-person-picker>
    <app-deadline-filter [showUntil]="false"
      [title]="'Data:'" [showLate]="false"
                         (onChange)="timestampChange($event)"
                         (onDateChange)="timestampDateChange($event)"></app-deadline-filter>
    <div mat-ripple class="save" (click)="newCS()">
      <div>+ Novo atendimento</div>
    </div>
  </div>

  <div class="item-counter-list">
    @for (status of statusMap.keys(); track status) {
      <app-item-counter
        [title]="statusMap.get(status)?.pluralName ?? ''"
        [value]="statusMap.get(status)?.count ?? 0"
        [titleColor]="statusMap.get(status)?.color ?? ''"
        [textColor]="(statusMap.get(status)?.invertTitleColor ?? false) ? 'white' : 'black'"
      ></app-item-counter>
      @if (statusMap.get(status)?.showSeparator) {
        <div class="counter-separator"></div>
      }
    }
  </div>
  <app-cs-table
    [values]="csService.csList()"
    [toBeDeleted]="toBeDeleted"
    [totalItems]="csService.csPagination()?.total ?? 0"
    [pageSize]="pageSize()"
    (pageChange)="onPageChange($event)"
    (openDetails)="openDetails($event)">
  </app-cs-table>
</div>
